// src/components/ServiceDetail/ServiceDetail.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './ServiceDetail.css';

// React Icons kütüphanesinden lüks ve kurumsal ikonlar
import { 
  FiShield, 
  FiHeart, 
  FiBriefcase, 
  FiUsers, 
  FiFileText, 
  FiHome, 
  FiCheckCircle,
  FiClock,
  FiLock,
  FiTarget
} from 'react-icons/fi';

import hero2 from '../../assets/hero2.jpg';
import hero3 from '../../assets/hero3.jpg';
import hero4 from '../../assets/hero4.jpg';
import hero5 from '../../assets/hero5.jpg';
import hero6 from '../../assets/hero6.jpg';
import hero1 from '../../assets/hero1.jpg';
import hero7 from '../../assets/hero7.jpg';

function ServiceDetail() {
  const { id } = useParams();

  // Tüm çalışma alanlarının detaylı ve profesyonel veritabanı
  const serviceData = {
    'ceza-hukuku': {
      title: 'Ceza Hukuku',
      icon: <FiShield />,
      image: hero1,
      subtitle: 'Kişi Hak ve Özgürlüklerinizin En Güçlü Savunması',
      desc1: 'Ceza Hukuku, kişi hak ve özgürlüklerinin en çok kısıtlanma riski taşıyan, en hassas ve geri dönüşü olmayan sonuçlar doğurabilen hukuk dalıdır. Bu nedenle soruşturma (kolluk/savcılık) ve kovuşturma (mahkeme) aşamalarının en başından itibaren titiz, öngörülü ve stratejik bir hukuki destek almanız hayati önem taşır.',
      desc2: 'Av. Emre Uygun Hukuk ve Danışmanlık Bürosu olarak; Ağır Ceza Mahkemeleri, Asliye Ceza Mahkemeleri ve Sulh Ceza Hakimliklerinde görülen tüm dosyalarda şüpheli, sanık müdafiliği ile müşteki/katılan vekilliği görevlerini mutlak mahremiyet ve profesyonellik ilkesiyle, sürecin her anında bizzat yanınızda olarak yürütmekteyim.',
      processTitle: 'Ceza Yargılamasında Nasıl Çalışıyoruz?',
      processDesc: 'Dosyanın ilk incelemesinden delillerin toplanmasına, ifade ve sorgu aşamalarından mahkeme savunmalarına kadar her adımı titizlikle planlıyor; hak kayıplarını önlemek için proaktif bir savunma stratejisi oluşturuyoruz.',
      list: [
        'Ağır Ceza Mahkemesi Davaları (Ağırlaştırılmış Müebbet, Nitelikli Dolandırıcılık vb.)', 
        'Asliye Ceza Mahkemesi Davaları', 
        'Kolluk ve Cumhuriyet Başsavcılığı Soruşturma Aşaması İfade ve Sorgu İşlemleri',
        'Bilişim Sistemleri Yoluyla İşlenen Suçlar ve Dijital Delil İncelemesi', 
        'Ekonomik ve Mali Suçlar, Vergi Kaçakçılığı ve Dolandırıcılık Dosyaları', 
        'İstinaf, Yargıtay ve Anayasa Mahkemesi Kanun Yolu Başvuruları'
      ]
    },
    'aile-hukuku': {
      title: 'Aile ve Boşanma Hukuku',
      icon: <FiHeart />,
      image: hero3,
      subtitle: 'Hassas Süreçlerinizde Güvenilir ve Gizlilik Odaklı Rehberlik',
      desc1: 'Aile hukuku uyuşmazlıkları, taraflar için hem hukuki hem de psikolojik açıdan son derece hassas ve yıpratıcı süreçler olabilmektedir. Temel amacım, bu süreçleri sizin için en az hasarla, en hızlı ve hak kaybetmeyeceğiniz şekilde sonuca ulaştırmaktır.',
      desc2: 'Anlaşmalı ve çekişmeli boşanma davaları başta olmak üzere; nafaka, velayet, maddi/manevi tazminat ve mal rejiminin tasfiyesi süreçlerinde mahremiyetinizi en üst düzeyde tutarak sonuç odaklı danışmanlık ve avukatlık hizmeti sunuyorum.',
      processTitle: 'Aile Hukukunda Çalışma Prensibimiz',
      processDesc: 'Taraflar arasındaki husumeti en aza indirmeyi, mümkün olan durumlarda anlaşmalı protokollerle süreci hızlandırmayı; çekişmeli hallerde ise haklarınızı (velayet, nafaka ve tazminat) en üst düzeyde korumayı ilke ediniyoruz.',
      list: [
        'Anlaşmalı Boşanma Protokolü Düzenlenmesi ve Dava Takibi', 
        'Çekişmeli Boşanma Davaları (Zina, Hayata Kast, Terk vb.)', 
        'Tedbir, İştirak, Yoksulluk ve Yoksulluk Nafakası Talepleri', 
        'Çocukların Velayeti ve Kişisel İlişki Kurulması', 
        'Mal Rejiminin Tasfiyesi ve Katkı Payı Alacağı Davaları'
      ]
    },
    'ticaret-hukuku': {
      title: 'Şirketler ve Ticaret Hukuku',
      icon: <FiBriefcase />,
      image: hero4,
      subtitle: 'Ticari Geleceğinizi Güvence Altına Alan Kurumsal Çözümler',
      desc1: 'Ticari hayatın dinamik yapısı içerisinde şirketlerin karşılaşabileceği hukuki riskleri önceden bertaraf etmek ve ticari faaliyetlerin güvenle yürütülmesini sağlamak ticaret hukukunun temelini oluşturur.',
      desc2: 'Şirketlerin kuruluş işlemlerinden sözleşmelerin hazırlanmasına, ticari uyuşmazlıkların çözümünden icra takiplerine kadar işletmenizin tüm hukuki süreçlerinde kurumsal danışmanlık vererek ticari geleceğinizi güvence altına alıyorum.',
      processTitle: 'Ticari Süreçleri Nasıl Yönetiyoruz?',
      processDesc: 'Şirketinizin operasyonel yapısını inceleyerek olası uyuşmazlıkları doğmadan engelliyor (koruyucu avukatlık); doğmuş uyuşmazlıklarda ise ticari itibarınızı ve menfaatlerinizi koruyacak en hızlı hukuki aksiyonu alıyoruz.',
      list: [
        'Şirketler Danışmanlığı, Ana Sözleşme Hazırlığı ve Tadili', 
        'Ticari Alacak, Tazminat ve Sözleşmeden Doğan Uyuşmazlıklar', 
        'Şirket Genel Kurul İşlemleri ve Yönetim Kurulu Kararları', 
        'Haksız Rekabetin Önlenmesi ve Ticari Sırların Korunması', 
        'Kıymetli Evrak (Çek, Bono, Poliçe) Hukuki Alacak Takipleri'
      ]
    },
    'is-hukuku': {
      title: 'İş ve Sosyal Güvenlik Hukuku',
      icon: <FiUsers />,
      image: hero5,
      subtitle: 'İşçi ve İşveren Haklarının Hakkaniyetle Korunması',
      desc1: 'İşçi ve işveren arasındaki ilişkilerin yasal mevzuata uygun ve hakkaniyetli bir şekilde yürütülmesi, iş akitlerinin feshi ve özlük haklarının korunması taraflar açısından büyük bir titizlik gerektirir.',
      desc2: 'Hizmet akdinden kaynaklanan kıdem ve ihbar tazminatı, fazla mesai alacakları, işe iade davaları ve iş kazalarından doğan hukuki sorumluluklar konusunda tarafların haklarını yasal çerçevede profesyonelce savunmaktayım.',
      processTitle: 'İş Hukuku Uyuşmazlıklarında Yol Haritamız',
      processDesc: 'Dava şartı arabuluculuk aşamasından, mahkeme sürecinin sonuna kadar taraflar arasındaki ekonomik ve hukuki dengeleri gözeterek en adil ve hızlı çözüme ulaşmayı hedefliyoruz.',
      list: [
        'Kıdem, İhbar ve Kötüniyet Tazminatı Davaları', 
        'İşe İade Davaları ve İşe Başlatmama Tazminatları', 
        'Fazla Mesai, Hafta Tatili ve Yıllık İzin Alacakları', 
        'İş Kazası ve Meslek Hastalığından Doğan Tazminat Davaları', 
        'İş Sözleşmelerinin Hukuki İncelemesi ve Fesih Bildirimleri'
      ]
    },
    'icra-hukuku': {
      title: 'İcra ve İflas Hukuku',
      icon: <FiFileText />,
      image: hero6,
      subtitle: 'Alacakların Hızlı Tahsili ve Borç Yapılandırma Çözümleri',
      desc1: 'Alacaklıların haklarına en kısa sürede kavuşabilmesi veya borçluların yasal haklarının korunması amacıyla icra hukuku süreçlerinin hızlı ve etkin yürütülmesi şarttır.',
      desc2: 'İlamlı ve ilamsız icra takipleri, kambiyo senetlerine özgü haciz yolları, borca itiraz süreçleri ve haciz/muhafaza işlemlerinin takibini ofisimde büyük bir titizlikle gerçekleştirerek alacak tahsilatını hızlandırmaktayım.',
      processTitle: 'İcra Takiplerinde Çalışma Sistemimiz',
      processDesc: 'Borçlu mal varlığı araştırmalarını etkin bir şekilde yapıyor, haciz ve muhafaza işlemlerini yasal süreler içerisinde icra müdürlükleri nezdinde bizzat takip ederek alacağınıza en kısa sürede kavuşmanızı sağlıyoruz.',
      list: [
        'İlamlı ve İlamsız Genel Haciz Yoluyla Takipler', 
        'Kambiyo Senetlerine (Çek, Bono) Özgü İcra Takipleri', 
        'İtirazın Kaldırılması ve İptali Davaları', 
        'Menfi Tespit ve İstirdat (Geri Alma) Davaları', 
        'Şirket İflas ve Konkordato Süreçlerinin Hukuki Takibi'
      ]
    },
    'gayrimenkul-hukuku': {
      title: 'Gayrimenkul Hukuku',
      icon: <FiHome />,
      image: hero7,
      subtitle: 'Mülkiyet Haklarınız ve Taşınmaz Uyuşmazlıklarında Uzman Çözümler',
      desc1: 'Tapu iptal ve tescil davaları, kamulaştırma, kira uyuşmazlıkları ve ortaklığın giderilmesi gibi gayrimenkul hukukunu ilgilendiren konular yüksek maddi değerler barındırdığından uzman takibi gerektirir.',
      desc2: 'Gayrimenkul alım-satım süreçlerindeki risklerin analizi, tapu sicilinde yaşanan uyuşmazlıkların giderilmesi ve mülkiyet haklarınızın korunması hususlarında detaylı hukuki danışmanlık ve dava takibi hizmeti sunuyorum.',
      processTitle: 'Gayrimenkul Davalarında İzlediğimiz Yol',
      processDesc: 'Tapu kayıtları, imar durumları ve sözleşmeler üzerinde detaylı inceleme yapıyor; mülkiyet hakkına yapılan müdahaleleri önlemek ve tapu güvenliğini sağlamak için titizlikle dava yürütüyoruz.',
      list: [
        'Tapu İptal ve Tescil Davaları (Hile, Muris Muvazaası vb.)', 
        'Ortaklığın Giderilmesi (İzalsei Şüyu) Davaları', 
        'Kira Alacağı, Uyarlama ve Tahliye Davaları', 
        'Kamulaştırma ve Bedel Artırım Davaları', 
        'Şufa (Önalım) ve El Atmanın Önlenmesi (Müdahalenin Men\'i) Davaları'
      ]
    }
  };

  // URL id bulunamazsa varsayılan fallback
  const currentService = serviceData[id] || {
    title: 'Çalışma Alanlarımız',
    icon: <FiShield />,
    image: hero2,
    subtitle: 'Hukuki Danışmanlık ve Avukatlık Hizmetleri',
    desc1: 'Hukuki ihtilaflarınızda yanınızdayım. Detaylı bilgi için lütfen menüden ilgili çalışma alanını seçiniz.',
    desc2: '',
    processTitle: 'Hizmet Anlayışımız',
    processDesc: 'Müvekkillerimizin haklarını en üst düzeyde korumak için şeffaf ve sonuç odaklı çalışıyoruz.',
    list: []
  };

  return (
    <div className="page-wrapper">
      <Navbar />
      
      {/* Üst Başlık */}
      <div className="service-header">
        <div className="service-header-overlay"></div>
        <div className="container">
          <span className="service-icon-large">{currentService.icon}</span>
          <h1 className="page-title">{currentService.title}</h1>
          <p className="page-subtitle-text">{currentService.subtitle}</p>
          <p className="page-breadcrumb">Ana Sayfa / Çalışma Alanları / {currentService.title}</p>
        </div>
      </div>

      {/* Detay İçeriği */}
      <section className="service-detail-section">
        <div className="container">
          <div className="service-detail-grid">
            
            {/* Sol Kısım: Genişletilmiş İçerik ve Hizmetler */}
            <div className="service-text-box">
              <h2 className="service-detail-heading">Hukuki <span className="gold-text">Süreç Yönetimi</span></h2>
              <div className="title-underline-left"></div>
              
              <p className="service-detail-desc">{currentService.desc1}</p>
              {currentService.desc2 && <p className="service-detail-desc">{currentService.desc2}</p>}
              
              {/* Nasıl Çalışıyoruz / Süreç Yönetimi Kutusu */}
              <div className="service-process-box">
                <h3 className="service-process-title">
                  <FiClock className="process-icon" /> {currentService.processTitle}
                </h3>
                <p className="service-process-desc">{currentService.processDesc}</p>
                <div className="process-badges">
                  <span className="badge"><FiLock /> Gizlilik</span>
                  <span className="badge"><FiTarget /> Stratejik Çözüm</span>
                </div>
              </div>

              {/* Bu Alandaki Hizmetlerimiz Listesi */}
              {currentService.list && currentService.list.length > 0 && (
                <div className="service-list-box">
                  <h3 className="service-list-title">Bu Alandaki Başlıca Hizmetlerim:</h3>
                  <ul className="service-feature-list">
                    {currentService.list.map((item, index) => (
                      <li key={index}>
                        <span className="check-icon"><FiCheckCircle /></span> {item}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Sağ Taraftaki Şık Görsel */}
            {currentService.image && (
              <div className="service-image-box">
                <img src={currentService.image} alt={currentService.title} className="service-img" />
                <div className="service-img-frame"></div>
              </div>
            )}

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ServiceDetail;